module.exports = __webpack_public_path__ + "img/set-complet-montserrat.882a008f.jpg";